module.exports = __webpack_public_path__ + "static/img/logo.b5cd3617.png";